<template>
  <section id="section3">
    <h1>{{ content['2.titel'] }}</h1>
    <h4>{{ content['2.ondertitel'] }}</h4>
    <Pager />
    <div>
      <Arrow-Button direction="down" v-scroll-to="'#section4-top'" />
    </div>
  </section>
</template>

<script>
import content from '@/content/website.json'
import ArrowButton from '@/components/home/ArrowButton.vue'
import Pager from '@/components/home/Pager.vue'

export default {
  name: 'Section3',
  components: {
    ArrowButton,
    Pager
  },
  data () {
    return {
      content
    }
  }
}
</script>

<style scoped lang="scss">
#section3 {
  position: relative;
  max-width: 99.2rem;
  margin: 0 auto;
  margin-bottom: 9rem;
  text-align: center;

  h1 {
    color: $color-orange;
  }

  h4 {
    text-transform: initial;
    margin-bottom: 3rem;
  }

  > div:last-child {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 3rem);
  }
}
</style>
